import moment from "moment";

import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { ClickableTextSectionEnum } from "@/Administration/Models/UI/Users/ClickableTextSectionEnum";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { RadioButtonv2 } from "@/Common/Components/Inputs/RadioButtonv2";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { Person } from "@/Common/Models/Person/Person";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { BritishColumbiaObstetricalFileClickableText } from "./BritishColumbiaObstetricalFileClickableText";
import { FaxCoverSheetClickableText } from "./FaxCoverSheetClickableText";
import { GroupSettingsComponent } from "./GroupSettingsComponent";
import { OntarioObstetricalFileClickableText } from "./OntarioObstetricalFileClickableText";
import { PopulationBasedFundingClickableText } from "./PopulationBasedFundingClickableText";
import { QuebecObstetricalFileClickableText } from "./QuebecObstetricalFileClickableText";

import styles from "@/Administration/Components/Users/UserToolsInfoEditComponent.module.scss";

interface IUserToolsInfoComponentProps {
    employeeModel: EmployeeUIModel;
    languageOptionForClickableText?: LanguageOptions;
    extendedSections: ClickableTextSectionEnum[];
    onExtendedSectionsChange: (sections: ClickableTextSectionEnum[]) => void;
}

class UserToolsInfoComponentState {
    public employeeResult: Employee;
}

class UserToolsInfoComponent extends React.Component<IUserToolsInfoComponentProps, UserToolsInfoComponentState> {
    private c1Paddingtop: React.CSSProperties = { paddingTop: "5px" };

    constructor(props: IUserToolsInfoComponentProps) {
        super(props);

        this.state = {
            employeeResult: props.employeeModel.Model
        };
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(prevProps: IUserToolsInfoComponentProps): void {
        let currentResult = this.props.employeeModel;
        let previousResult = prevProps.employeeModel;

        if (currentResult !== previousResult) {
            this.mutateState(s => { s.employeeResult = currentResult.Model; });
        }
    }

    public render(): JSX.Element {
        let employee = this.props.employeeModel;
        const selectedLanguageOptionforClickableText = sessionStore.getLanguageStringFromEnum(this.props.languageOptionForClickableText);

        let obstetreicalFileProps = {
            user: this.pEmployee(),
            languageOption: this.props.languageOptionForClickableText,
            readonly: true
        };

        return (
            <div>
                <div className="user-component">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("SharedInformationLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered">
                        <div className="tb">
                            {this.RenderSharingInfo()}
                        </div>
                    </div>

                </div>

                <div className="user-component">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("DynamicPdfAndUsefulLinksLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered">
                        <div className="tb">
                            {this.RenderPdfAndLinksInfo()}
                        </div>
                    </div>
                </div>

                <div className="user-component">
                    <div className="flex-container flex-column heading" style={{ "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("ClickableTextsLabel")}</h3>
                        </div>
                        <hr className="fullWidth margin-y-0" />
                    </div>

                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="psingle-column practice centered">
                            <div className="tb">
                                <div className="tbc">
                                    <div>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="c1" style={{ "paddingLeft": "5px", "paddingTop": "5px", "verticalAlign": "top" }}>
                                                        <label className="form-label" style={{ "paddingTop": "15px" }}> {cacheStore.GetString("LanguageLabel")}</label>
                                                    </td>
                                                    <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                                        <div style={{ "width": "350px", "verticalAlign": "top" }}>
                                                            <RadioButtonv2
                                                                cssClass="settings-user-radioWidth"
                                                                title={null}
                                                                items={[
                                                                    new KeyValuePair("fr", cacheStore.GetString("FrenchLabelD")),
                                                                    new KeyValuePair("en", cacheStore.GetString("EnglishLabelD")),
                                                                    new KeyValuePair("es-MX", cacheStore.GetString("SpanishLabelD"))
                                                                ].toImmutable()}
                                                                htmlName="prescription"
                                                                onChangeCallback={item => this.onChangeLanguageClickableText(item)}
                                                                selectedItem={selectedLanguageOptionforClickableText}
                                                                styleForEachradio={{ width: "22%", float: "left", marginTop: "5px" }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.obstetrcialFileWidthOverride}>
                        {employee.Type === EmployeeType.Practician &&
                        this.renderClickableTextOptions(ClickableTextSectionEnum.ClinicalNote, "ClinicalNoteLabel", this.renderClickableNote())
                        }
                        {employee.hasSiteInProvince(CanadaState.Quebec) && cacheStore.ClinicSettings.EnableQuebecObstetricalFile &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.QuebecObstetricalFile,
                            "QuebecObstetricalFileLabel",
                            <QuebecObstetricalFileClickableText {...obstetreicalFileProps} />
                        )
                        }
                        {employee.hasSiteInProvince(CanadaState.Ontario) && cacheStore.ClinicSettings.EnableOntarioObstetricalFile &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.OntarioObstetricalFile,
                            "OntarioObstetricalFileLabel",
                            <OntarioObstetricalFileClickableText {...obstetreicalFileProps} />
                        )
                        }
                        {employee.hasSiteInProvince(CanadaState.BritishColumbia) && cacheStore.ClinicSettings.EnableBritishColumbiaObstetricalFile &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.BritishColumbiaObstetricalFile,
                            "BritishColumbiaObstetricalFileLabel",
                            <BritishColumbiaObstetricalFileClickableText {...obstetreicalFileProps} />
                        )
                        }
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.Recalls, "RecallsLabel", this.renderRecall())}
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.InboundFax, "InboundFaxLabel", this.renderInboundFax())}
                        {cacheStore.ClinicSettings.EnableFaxCoverSheet && this.renderClickableTextOptions(
                            ClickableTextSectionEnum.FaxCoverSheet,
                            "FaxCoverSheet_FaxCoverSheetLabel",
                            <FaxCoverSheetClickableText
                                readonly
                                user={this.pEmployee()}
                                languageOptions={this.props.languageOptionForClickableText}
                            />
                        )
                        }
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.Messages, "MessagesLabel", this.renderMessages())}
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.Tasks, "TaskLabel", this.renderTasks())}
                        {cacheStore.ClinicSettings.EnablePopulationBasedFunding &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.PopulationBasedFunding,
                            "PopulationBasedFundingLabel",
                            <PopulationBasedFundingClickableText
                                user={this.pEmployee()}
                                languageOption={this.props.languageOptionForClickableText}
                                readonly={true}
                            />
                        )
                        }
                        {cacheStore.ClinicSettings?.EnablePrescriptionRenewal && this.renderClickableTextOptions(ClickableTextSectionEnum.PrescriptionRenewalNotes, "PrescriptionRenewalLabel", this.renderPrescriptionRenewalNotes())}
                        {cacheStore.ClinicSettings?.EnableResultsFixes && this.renderClickableTextOptions(ClickableTextSectionEnum.ResultNotes, "ResultLabel", this.renderResultNotes())}
                        {cacheStore.ClinicSettings?.EnableBidirectionalCommunication && this.renderClickableTextOptions(ClickableTextSectionEnum.PortalCommunications, "SharedItem_PortalCommunicationsLabel", this.renderPortalCommunication())}
                    </div>
                </div>
            </div>
        );
    }

    private RenderSharingInfo(): JSX.Element {
        let employee = this.pEmployee();
        let taskClinicians: Person[] = [];
        let msgClinicians: Person[] = [];
        let externalCommClinicians: Person[] = [];
        let taskCliniciansNames = null;
        let messageCliniciansNames = null;
        let externalCommCliniciansNames = null;
        let portalCommunicationsCliniciansNames = null;
        let transferLabs = null;

        if (employee.Model.TasksSharing) {
            taskClinicians = cacheStore.CliniciansAndEmployeeGroups.filter(c => {
                let i = employee.Model.TasksSharing.filter(z => z === c.ContactId).length;
                return i > 0;
            });

            taskClinicians = taskClinicians.filter(x => x.ContactFacetId != employee.Model.ContactFacet_id);

            taskCliniciansNames = taskClinicians.map((x, idx) => (
                <div key={"taskClinicians_" + idx}>{x.NameWithPrefix}</div>
            ));
        }
        if (employee.Model.MessagesSharing) {
            msgClinicians = cacheStore.CliniciansAndEmployeeGroups.filter(c => {
                let i = employee.Model.MessagesSharing.filter(z => z === c.ContactId).length;
                return i > 0;
            });

            msgClinicians = msgClinicians.filter(x => x.ContactFacetId != employee.Model.ContactFacet_id);

            messageCliniciansNames = msgClinicians.map((x, idx) => (
                <div key={"msgClinicians_" + idx}> {x.NameWithPrefix}</div>
            ));
        }
        if (employee.Model.ExternalCommunicationsSharing) {
            externalCommClinicians = cacheStore.CliniciansAndEmployeeGroups.filter(
                c => employee.Model.ExternalCommunicationsSharing.filter(e => e === c.ContactId).length > 0
            );

            externalCommClinicians = externalCommClinicians.filter(x => x.ContactFacetId != employee.Model.ContactFacet_id);

            externalCommCliniciansNames = externalCommClinicians.map(x => (
                <div key={x.ContactFacetId}> {x.NameWithPrefix}</div>
            ));
        }

        if (
            cacheStore.ClinicSettings.EnableBidirectionalCommunication
            && employee.Model.PortalCommunicationsSharing?.length > 0
        ) {
            portalCommunicationsCliniciansNames = cacheStore
                .CliniciansAndEmployeeGroups
                .filter(employees => employee
                    .Model
                    .PortalCommunicationsSharing
                    .filter(sharedEmployeeId => sharedEmployeeId === employees.ContactId)
                    .length > 0
                )
                .filter(p => p.ContactFacetId != employee.Model.ContactFacet_id)
                .map(p => (<div key={p.ContactFacetId}> {p.NameWithPrefix}</div>));
        }

        if (employee.Model.OrphanLabForwardDTOs) {
            if (employee.Model.OrphanLabForwardDTOs.length > 0) {
                transferLabs = employee.Model.OrphanLabForwardDTOs.map((x, idx) => (
                    <div key={"msgClinicians_" + idx}>
                        <div style={{ "float": "left", "width": "350px", "whiteSpace": "nowrap", "textOverflow": "ellipsis", "overflow": "hidden" }}>
                            {x.ForwardedToName} {x.ForwardedTo && (" (" + x.ForwardedTo + ")")}
                        </div>
                        <div style={{ "float": "left", "paddingLeft": "10px", "paddingRight": "10px", "width": "100px" }}>
                            <strong>
                                {MyleHelper.ReplaceEmptyString((x.FromDate) ? moment(x.FromDate).format("YYYY-MM-DD") : "")}
                            </strong>
                        </div>
                        <div>
                            <strong>
                                {MyleHelper.ReplaceEmptyString((x.ToDate) ? moment(x.ToDate).format("YYYY-MM-DD") : "")}
                            </strong>
                        </div>
                    </div>
                ));
            }
        }

        return (
            <div className="tbc">
                {cacheStore.ClinicSettings.EnableUserSettingsUiImprovements && (
                    <GroupSettingsComponent
                        onDeleteGroupCallback={null}
                        onGroupSelectCallback={null}
                        selectedGroups={employee.Model.Groups}
                        editable={false}
                        className="group-settings"
                    />
                )}
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("ResultsLabel")}</label></td>
                                <td className="c2" style={this.c1Paddingtop}>
                                    <div>
                                        <CheckboxControl
                                            id="employee_ShareResultsDLabel"
                                            operation={null}
                                            target={CheckboxTarget.Unassigned}
                                            label={cacheStore.GetString("ShareResultsDLabel")}
                                            checked={employee.Model.IsSharingLabs}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("MessagesSharedWithLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(messageCliniciansNames)}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("TasksSharedWithLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(taskCliniciansNames)}</strong></td>
                            </tr>
                            {cacheStore.ClinicSettings.EnableExternalCommunication && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("ExternalCommunicationSharedWithLabel")}</label></td>
                                    <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(externalCommCliniciansNames)}</strong></td>
                                </tr>
                            )}
                            {cacheStore.ClinicSettings.EnableBidirectionalCommunication && (
                                <>
                                    {(cacheStore.ClinicSettings.EnablePatientInitiatedBidirectionalCommunication && !employee.isClerical()) && (
                                        <tr>
                                            <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SharedItem_PortalCommunicationsLabel")}</label></td>
                                            <td className="c2" style={this.c1Paddingtop}>
                                                <div>
                                                    <CheckboxControl
                                                        id="employee_EnablePatientsToInitiatePortalMessagesLabelShareResults"
                                                        operation={null}
                                                        target={CheckboxTarget.Unassigned}
                                                        label={cacheStore.GetString("Administration_EnablePatientsToInitiatePortalMessagesWithProviderLabel")}
                                                        checked={employee.Model.AllowPatientsToInitiatePortalMessages}
                                                        labelClassName={styles.breakWordCheckboxLabel}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("SharedItem_PortalCommunicationsSharedWithLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(portalCommunicationsCliniciansNames)}</strong></td>
                                    </tr>
                                </>
                            )}
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("TransferResultLabel")}</label></td>
                                <td className="c2" style={this.c1Paddingtop}><strong>{MyleHelper.ReplaceEmptyString(transferLabs)}</strong></td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private RenderPdfAndLinksInfo(): JSX.Element {
        let employee = this.pEmployee();
        let usefulLinkUrl = null;

        let url = employee.Model.UsefulLinks;
        if (url != null) {
            if (url.length > 0) {
                let parts = url[0].split(";");
                usefulLinkUrl = parts;
            }
        }

        return (
            <div className="tbc">
                <div>
                    <table>
                        <tbody>

                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("DynamicPdfLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(employee.getFormattedAllowedTags(employee.Model.AllowedFormTags))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("QuickLinkLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                    {usefulLinkUrl != null && (usefulLinkUrl.map((link: string, idx) => {
                                        let l = $.trim(link);
                                        let href = l;
                                        if (l.length === 0) return null;
                                        if (l.indexOf("http") < 0) { href = "http://" + l; }
                                        return (
                                            <div key={idx + "_usefulLinks"} style={{ "whiteSpace": "nowrap", "textOverflow": "ellipsis", "overflow": "hidden" }}><a style={{ marginRight: "5px" }} href={href} target="_blank">{l}</a></div>

                                        );
                                    }))}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderClickableNote(): JSX.Element {
        let employee = this.pEmployee();
        let textList = employee.Model.TextList;
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.languageOptionForClickableText;
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let notesReason = (textList) ? employee.getAggregatedTabNames("RFV", lang) : null;
        let notesHistory = (textList) ? employee.getAggregatedTabNames("HPI", lang) : null;
        let notesExam = (textList) ? employee.getAggregatedTabNames("EXAM", lang) : null;
        let notesLab = (textList) ? employee.getAggregatedTabNames("LAB", lang) : null;
        let notesImaging = (textList) ? employee.getAggregatedTabNames("IMG", lang) : null;
        let notesOther = (textList) ? employee.getAggregatedTabNames("OTHN", lang) : null;
        let notesFollowUpPlan = (textList) ? employee.getAggregatedTabNames("OTH", lang) : null;
        let allConsultation = (textList) ? employee.getAggregatedTabNames("CONS", lang) : null;
        let allRequest = (textList) ? employee.getAggregatedTabNames("REQ", lang) : null;
        let requestReason = (textList) ? employee.getAggregatedTabNames("RFRQ", lang) : null;
        let consultationRequestReason = (textList) ? employee.getAggregatedTabNames("RFCR", lang) : null;

        let reasons = "";
        let histories = "";
        let exams = "";
        let labs = "";
        let images = "";
        let others = "";
        let followUpPlan = "";

        if (notesReason) {
            reasons = notesReason.map((r: { TabName: string; }) => r.TabName).join(", ");
        }

        if (notesHistory) {
            histories = notesHistory.map((h: { TabName: string; }) => h.TabName).join(", ");
        }

        if (notesExam) {
            exams = notesExam.map((e: { TabName: string; }) => e.TabName).join(", ");
        }

        if (notesLab) {
            labs = notesLab.map((l: { TabName: string; }) => l.TabName).join(", ");
        }

        if (notesImaging) {
            images = notesImaging.map((i: { TabName: string; }) => i.TabName).join(", ");
        }

        if (notesOther) {
            others = notesOther.map((o: { TabName: string; }) => o.TabName).join(", ");
        }

        if (notesFollowUpPlan) {
            followUpPlan = notesFollowUpPlan.map((flp: { TabName: string; }) => flp.TabName).join(", ");
        }

        // get consultations
        let consultations = "";
        if (allConsultation) {
            consultations = allConsultation.map((c: { TabName: string; }) => c.TabName).join(", ");
        }

        // get labRequest
        let request = "";
        if (allRequest) {
            request = allRequest.map((r: { TabName: string; }) => r.TabName).join(", ");
        }

        let reqReasons = "";
        if (requestReason) {
            reqReasons = requestReason.map((rr: { TabName: string; }) => rr.TabName).join(", ");
        }

        let conReqReasons = "";
        if (consultationRequestReason) {
            conReqReasons = consultationRequestReason.map((crr: { TabName: string; }) => crr.TabName).join(", ");
        }

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>

                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("ReasonLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(reasons)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("HPILabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(histories)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("ExamLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(exams)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("LaboratoryLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(labs)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("RadiologyLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(images)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("OtherNotesAndInterventionsLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(others)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("RequestsLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(request)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("RequestReasonLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(reqReasons)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("ConsultationRequestLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(consultations)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("ConsultationRequestReasonLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(conReqReasons)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("OtherPlanNoteLbl")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(followUpPlan)}</strong></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    private renderRecall(): JSX.Element {
        let employee = this.pEmployee();
        let textList = employee.Model.TextList;
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.languageOptionForClickableText;
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let notesR = "";
        let notesRecall: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("RNOTES", lang) : [];
        if (notesRecall) {
            notesR = notesRecall.map(n => n.TabName).join(", ");
        }

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("NotesDLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(notesR)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderInboundFax(): JSX.Element {
        const employee = this.pEmployee();
        let textList = [...employee.Model.TextList];
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.languageOptionForClickableText;
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let notesReturnFaxToSender = "";
        let regularNotes = "";
        const returnFaxToSenderMessages: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("ReturnToSenderNotes", lang) : [];
        const inboundFaxNotes: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("InboundFaxNotes", lang) : [];

        if (inboundFaxNotes)
            regularNotes = inboundFaxNotes.map(n => n.TabName).join(", ");

        if (returnFaxToSenderMessages)
            notesReturnFaxToSender = returnFaxToSenderMessages.map(r => r.TabName).join(", ");

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("ReturnToSenderNotesLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(notesReturnFaxToSender)}</strong></td>
                                    </tr>

                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("NotesDLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(regularNotes)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderPrescriptionRenewalNotes(): JSX.Element {
        const employee = this.pEmployee();
        let textList = [...employee.Model.TextList];
        if (textList && textList.length > 0)
            textList.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.languageOptionForClickableText;
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const prescriptionRenewalNotes: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("PrescriptionRenewalNotes", lang) : [];
        const regularNotes = (prescriptionRenewalNotes) ? prescriptionRenewalNotes.map(n => n.TabName).join(", ") : "";

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("NotesLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(regularNotes)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderResultNotes(): JSX.Element {
        const employee = this.pEmployee();
        const textList = [...employee.Model.TextList];
        if (textList && textList.length > 0)
            textList.sortByProperty(x => x.TabOrderIndex);
        const langClickableText = this.props.languageOptionForClickableText;
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const resultNotes: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("ResultNotes", lang) : [];
        const regularNotes = (resultNotes) ? resultNotes.map(n => n.TabName).join(", ") : "";

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <label className="form-label">{cacheStore.GetString("NotesLabel")}</label>
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>{MyleHelper.ReplaceEmptyString(regularNotes)}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderMessages(): JSX.Element {
        let employee = this.pEmployee();
        let textList = employee.Model.TextList;
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.languageOptionForClickableText;
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let message = "";
        let bMessages = "";
        let messages = (textList) ? employee.getAggregatedTabNames("SMESSAGES", lang) : null;
        let bodyMessages = (textList) ? employee.getAggregatedTabNames("BMESSAGES", lang) : null;

        if (messages) {
            for (let i = 0; i < messages.length; i++) {
                message += messages[i].TabName + (i != messages.length - 1 ? ", " : "");
            }
        }
        if (bodyMessages) {
            for (let i = 0; i < bodyMessages.length; i++) {
                bMessages += bodyMessages[i].TabName + (i != bodyMessages.length - 1 ? ", " : "");
            }
        }

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>

                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("SubjectLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(message)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("BodyLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(bMessages)}</strong></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderTasks(): JSX.Element {
        let employee = this.pEmployee();
        let textList = employee.Model.TextList;
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.languageOptionForClickableText;
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let task = "";
        let bTask = "";

        let tasks = (textList) ? employee.getAggregatedTabNames("STASKS", lang) : null;
        let bodyTask = (textList) ? employee.getAggregatedTabNames("BTASKS", lang) : null;

        if (tasks) {
            for (let i = 0; i < tasks.length; i++) {
                task += tasks[i].TabName + (i != tasks.length - 1 ? ", " : "");
            }
        }
        if (bodyTask) {
            for (let i = 0; i < bodyTask.length; i++) {
                bTask += bodyTask[i].TabName + (i != bodyTask.length - 1 ? ", " : "");
            }
        }

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>

                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("SubjectLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(task)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("BodyLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(bTask)}</strong></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderPortalCommunication(): JSX.Element {
        const employee = this.pEmployee();
        const textList = [...employee.Model.TextList];
        if (textList?.length)
            textList.sortByProperty(p => p.TabOrderIndex);
        const langClickableText = this.props.languageOptionForClickableText;
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const portalCommunicationNotes: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("PORTAL", lang) : [];
        const regularNotes = (portalCommunicationNotes) ? portalCommunicationNotes.map(p => p.TabName).join(", ") : "";
        const portalCommunicationSubjects: ClickableTextItem[] = (textList) ? employee.getAggregatedTabNames("PortalSubject", lang) : [];
        const portalCommunicationSubjectClickableTexts = (portalCommunicationSubjects) ? portalCommunicationSubjects.map(p => p.TabName).join(", ") : "";

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("SubjectLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(portalCommunicationSubjectClickableTexts)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("MessageLabel")}</label></td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(regularNotes)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public pEmployee(): EmployeeUIModel {
        return this.props.employeeModel;
    }

    private mutateState(mutation: (s: UserToolsInfoComponentState) => void, then: () => void = null): void {
        var s = new UserToolsInfoComponentState();
        mutation(s);
        this.setState(s, then);
    }

    private onChangeLanguageClickableText(item: KeyValuePair<string, string>): void {
        let lang: LanguageOptions;
        if (item.Key === "en")
            lang = LanguageOptions.English;
        else if (item.Key === "fr")
            lang = LanguageOptions.French;
        else if (item.Key === "es-MX")
            lang = LanguageOptions.Spanish;

        sessionStore.dispatch(LocalOperations.AdministrationUsers.OnChangeLanguageForClickableText, { LanguageOption: lang });
    }

    private renderClickableTextOptions(sectionType: ClickableTextSectionEnum, titleLabel: string, renderContent: JSX.Element): JSX.Element {
        const isSectionExtended = this.props.extendedSections.contains(sectionType);
        return (
            <div className={`margin-lg-right margin-lg-left ${styles.clickableTextWrapperBorder}`}>
                <div className="flex-container heading clickable-text-row-wrapper">
                    <div className="h clickable-text-title" onClick={() => this.onClickableTextSectionToggle(sectionType)}>
                        <h3 className="thin-font">{cacheStore.GetString(titleLabel)}</h3>
                        <span className={`clickable-text-arrow glyphicon glyphicon-chevron-${isSectionExtended ? "up" : "down"}`} />
                    </div>
                </div>
                {isSectionExtended &&
                    renderContent
                }
            </div>
        );
    }

    private onClickableTextSectionToggle(sectionType: ClickableTextSectionEnum): void {
        const extendedSections = this.props.extendedSections;
        if (!extendedSections)
            return;

        extendedSections.toggleElement(sectionType);
        this.props.onExtendedSectionsChange?.(extendedSections);
    }
}

export { UserToolsInfoComponent };
